import React, {Suspense} from 'react';
import {useParams} from 'react-router-dom';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {
	UpdateVoyageTemplateLazy
} from "@containers/singleVoyage/voyageTemplates/mutateTemplate/updateTemplate/UpdateVoyageTemplate.lazy";

const UpdateVoyageTemplatePage = () => {

	const {templateId} = useParams()

	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<UpdateVoyageTemplateLazy
					templateId={Number(templateId)}
				/>
			</Suspense>
		</PageLayout>
	);
};

export default UpdateVoyageTemplatePage;
